export default __webpack_public_path__ + "static/media/fusion.d59585ad.jpg";